import { allFilterBys } from './filter-options';
import { useSuppliersGridContext } from './suppliers-grid-context';
import FilterBar from '../../../components/filter-bar';
import { criteriaOperatorsMap } from '../../../containers/base-filter-bar-container/criteria-operators';
import style from '../../../containers/orders-filter-bar-container/style.module.less';

export const SuppliersFilterBar = () => {
  const { appliedFilters, onFiltersChanged, clearFilters } = useSuppliersGridContext();

  return (
    <div className={style['filter-bar-wrapper']}>
      <FilterBar
        allFilterBys={allFilterBys}
        appliedFilters={appliedFilters}
        clearFilters={clearFilters}
        criteriaOperatorsMap={criteriaOperatorsMap}
        onFiltersChanged={onFiltersChanged}
        popularFilterBys={allFilterBys}
      />
    </div>
  );
};
